// 页面类型
export const PAGES_MAP = {
  0: {
    name: 'H5链接',
  },
  1: {
    name: "首页",
    url: "./",
  },
  2: {
    name: "个人中心",
    url: "./me.html",
  },
  3: {
    name: "课程列表",
    url: "./index.html",
  },
  4: {
    name: "课程详情",
    url: "./course.html",
  }
}

// 链接方式
export const LINKS_MAP = {
  1: {
    name: "同端跳转",
    key: "same"
  },
  2: {
    name: "跳转h5",
    key: "h5"
  },
  3: {
    name: "跳转native",
    key: "native"
  }
}


export const isH5Page = (pageType) => {
  if (PAGES_MAP[pageType]) {
    return true;
  }
  return false;
}